import categoryUserSitePublisherActions from "../actions/categoryUserSitePublisher";

const mainState = {
  render: 0,
  name_category: null,
  start_date: null,
  end_date: null,
  type_action: null,
  count_positions_selected: 0,
  position_added_in_edit_action: [],
  /*
  this is pattern data_site_publisher
  {
    site_publisher_id :{
      page_id :  {
        title : 'صفحه اصلی',
        positions: [tag_html_id , ... ],
        price : 20000
      },
      ...,
      url : "monirlock.ir"
    },
    ...
  }

  {
    1 :{
      1 : {
        title : 'صفحه اصلی',
        positions:  [#hilite-position-1 , #hilite-position-2 ,#hilite-position-3 ],
        price : 20000
      },
      2 : {
        title : 'صفحات مطالب',
        positions:   [#hilite-position-4 , #hilite-position-5  ],
        price : 50000
      },
      url : "monirlock.ir"
    },
    2 : {
       3 : {
        title : 'صفحه اصلی',
        positions:  [#hilite-position-55 , #hilite-position-66 ,#hilite-position-333 ],
        price : 660000
      },
      4 : {
        title : 'صفحات مطالب',
        positions:   [#hilite-position-54, #hilite-position-45  ],
        price : 230000
      },
      url : "pattlock.ir"
    }
  }  
  */
  data_site_publisher: new Object(),
};

const addTagHtmlIDToPageID = (
  sitePublisherID,
  pageID,
  pageTitle,
  positionTagHtmlID,
  sitePublisherUrl,
  positionPrice,
  positionSize,
  positionBasePrice,
  positionCount,
  positionsSitePublisher
) => {
  positionsSitePublisher =
    checkExistOrADDSitePublisherIDInPositionsSitePublisher(
      positionsSitePublisher,
      sitePublisherID,
      sitePublisherUrl
    );

  positionsSitePublisher = checkExistOrAddPageIDInSitePublisherID(
    positionsSitePublisher,
    sitePublisherID,
    pageTitle,
    pageID
  );

  positionsSitePublisher = checkExistOrAddTagHtmlIDnPageID(
    positionsSitePublisher,
    sitePublisherID,
    pageID,
    positionPrice,
    positionSize,
    positionBasePrice,
    positionCount,
    positionTagHtmlID
  );

  return positionsSitePublisher;
};

const checkExistOrAddTagHtmlIDnPageID = (
  positionsSitePublisher,
  sitePublisherID,
  pageID,
  positionPrice,
  positionSize,
  positionBasePrice,
  positionCount,
  positionTagHtmlID
) => {
  let arrayPositionsTagHtmID = [];
  let positionsData = [];
  let pricePage = positionsSitePublisher[sitePublisherID][pageID].price;

  const positionsTagHtmlIDS = positionsSitePublisher[sitePublisherID][
    pageID
  ].positions.map((position) => position.tagHtmlID);
  if (positionsTagHtmlIDS.includes(positionTagHtmlID)) {
    if (
      positionsSitePublisher[sitePublisherID][pageID].positions.length === 1
    ) {
      return removePageObjectInSitePublisher(
        positionsSitePublisher,
        sitePublisherID,
        pageID
      );
    }

    arrayPositionsTagHtmID = positionsSitePublisher[sitePublisherID][
      pageID
    ].positions.filter((position) => {
      if (position.tagHtmlID != positionTagHtmlID) {
        return position;
      }
    });

    if (positionsSitePublisher[sitePublisherID][pageID].positions_report) {
      positionsData = positionsSitePublisher[sitePublisherID][
        pageID
      ].positions_report.filter((position) => {
        if (position.tag_html_id != positionTagHtmlID) {
          return position;
        }
      });
    }

    pricePage = pricePage - positionPrice;
  } else {
    arrayPositionsTagHtmID = [
      ...positionsSitePublisher[sitePublisherID][pageID].positions,
      {
        tagHtmlID: positionTagHtmlID,
        price: positionPrice,
      },
    ];
    positionsData = [
      ...positionsSitePublisher[sitePublisherID][pageID].positions_report,
      {
        price: positionPrice,
        size: positionSize,
        base_price: positionBasePrice,
        count: positionCount,
        tag_html_id: positionTagHtmlID,
      },
    ];

    pricePage = pricePage + positionPrice;
  }

  positionsSitePublisher[sitePublisherID][pageID].positions =
    arrayPositionsTagHtmID;
  positionsSitePublisher[sitePublisherID][pageID].price = pricePage;
  positionsSitePublisher[sitePublisherID][pageID].positions_report =
    positionsData;
  return positionsSitePublisher;
};

const removePageObjectInSitePublisher = (
  positionsSitePublisher,
  sitePublisherID,
  pageID
) => {
  delete positionsSitePublisher[sitePublisherID][pageID];
  if (Object.keys(positionsSitePublisher[sitePublisherID]).length === 1) {
    delete positionsSitePublisher[sitePublisherID];
  }
  return positionsSitePublisher;
};

const checkExistOrAddPageIDInSitePublisherID = (
  positionsSitePublisher,
  sitePublisherID,
  pageTitle,
  pageID
) => {
  if (positionsSitePublisher[sitePublisherID][pageID] === undefined) {
    positionsSitePublisher = addPageIDInSitePublisherID(
      positionsSitePublisher,
      sitePublisherID,
      pageTitle,
      pageID
    );
  }
  return positionsSitePublisher;
};

const addPageIDInSitePublisherID = (
  positionsSitePublisher,
  sitePublisherID,
  pageTitle,
  pageID
) => {
  let object2 = new Object();
  object2[pageID] = new Array();
  object2[pageID] = {
    title: pageTitle,
    price: 0,
    positions: [],
    positions_report: [],
  };

  let object1 = new Object();
  object1[sitePublisherID] = {
    ...positionsSitePublisher[sitePublisherID],
    ...object2,
  };

  positionsSitePublisher = {
    ...positionsSitePublisher,
    ...object1,
  };

  return positionsSitePublisher;
};

const checkExistOrADDSitePublisherIDInPositionsSitePublisher = (
  positionsSitePublisher,
  sitePublisherID,
  sitePublisherUrl
) => {
  if (positionsSitePublisher[sitePublisherID] === undefined) {
    positionsSitePublisher = addSitePublisherID(
      sitePublisherID,
      positionsSitePublisher,
      sitePublisherUrl
    );
  }

  return positionsSitePublisher;
};

const addSitePublisherID = (
  sitePublisherID,
  positionsSitePublisher,
  sitePublisherUrl
) => {
  let object = new Object();
  object[sitePublisherID] = new Object();
  object[sitePublisherID] = {
    url: sitePublisherUrl,
  };
  positionsSitePublisher = {
    ...positionsSitePublisher,
    ...object,
  };

  return positionsSitePublisher;
};

const main = (state = mainState, action) => {
  let newState = state;
  let sitePublisherID;
  let pageID;
  switch (action.type) {
    case categoryUserSitePublisherActions.ADD_POSITION:
      sitePublisherID = action.payload.web_site_publisher_id;
      pageID = action.payload.page_id;
      let pageTitle = action.payload.page_title;
      let positionTagHtmlID = action.payload.position_tag_html_id;
      let sitePublisherUrl = action.payload.site_publisher_url;
      let positionPrice = action.payload.position_price;
      let positionSize = action.payload.position_size;
      let positionBasePrice = action.payload.position_base_price;
      let positionCount = action.payload.position_count;

      let newPositionsSitePublisher = addTagHtmlIDToPageID(
        sitePublisherID,
        pageID,
        pageTitle,
        positionTagHtmlID,
        sitePublisherUrl,
        positionPrice,
        positionSize,
        positionBasePrice,
        positionCount,
        state.data_site_publisher
      );

      newState = {
        ...state,
        render: !state.render,
        data_site_publisher: newPositionsSitePublisher,
      };
      break;

    case categoryUserSitePublisherActions.EMPTY_POSITION:
      newState = {
        ...state,
        data_site_publisher: [],
      };
      break;

    case categoryUserSitePublisherActions.RESET_DATE:
      newState = {
        ...state,
        name_category: null,
        start_date: null,
        end_date: null,
      };
      break;

    case categoryUserSitePublisherActions.SET_POSITION_FOR_EDIT:
      newState = {
        ...state,
        data_site_publisher: action.payload.dataSitePublisher,
        render: !state.render,
      };
      break;

    case categoryUserSitePublisherActions.SET_DATE:
      newState = {
        ...state,
        name_category: action.payload.name_category,
        start_date: action.payload.start_date,
        end_date: action.payload.end_date,
      };
      break;

    case categoryUserSitePublisherActions.SET_TYPE_ACTION:
      newState = {
        ...state,
        type_action: action.payload.type_action,
      };
      break;

    case categoryUserSitePublisherActions.POSITION_ADDED_IN_EDIT_ACTION:
      newState = {
        ...state,
        position_added_in_edit_action: [
          ...state.position_added_in_edit_action,
          action.payload.position,
        ],
      };
      break;

    case categoryUserSitePublisherActions.RESET_POSITION_IN_EDIT_ACTION:
      newState = {
        ...state,
        position_added_in_edit_action: [],
      };
      break;
  }

  return newState;
};

export default main;
